module.exports = __webpack_public_path__ + "img/home_modal_poster2.67118aaa.png";